import { render, staticRenderFns } from "./imNotice.vue?vue&type=template&id=072f75e6&scoped=true"
import script from "./imNotice.vue?vue&type=script&lang=js"
export * from "./imNotice.vue?vue&type=script&lang=js"
import style0 from "./imNotice.vue?vue&type=style&index=0&id=072f75e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072f75e6",
  null
  
)

export default component.exports